import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import { NButton, NFormItem, NInput, NInputNumber, NSelect, NProgress, NCard, NTable, NThead, NTbody, NTh, NTr, NTd, NSpace } from 'naive-ui'
import EmbedCode from "@/components/embed";

const STORE_KEY = 'cgpa';

function Course() {
    return {
        name: '',
        grade: null,
        credits: null
    }
}

createApp({
    components: { NButton, NFormItem, NInput, NInputNumber, NSelect, NProgress, NCard, NTable, NThead, NTbody, NTh, NTr, NTd, NSpace, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        if (typeof localStorage === 'undefined') {
            return;
        }

        let semesters = this.initSemestersValue();

        if (typeof localStorage !== 'undefined') {
            semesters = JSON.parse(localStorage.getItem(STORE_KEY)) || semesters;
        }

        return {
            semesters,
            grades: [
                {
                    label: "-",
                    value: null
                },
                {
                    label: "A",
                    value: 4
                },
                {
                    label: "A-",
                    value: 3.7
                },
                {
                    label: "B+",
                    value: 3.3
                },
                {
                    label: "B",
                    value: 3
                },
                {
                    label: "B-",
                    value: 2.7
                },
                {
                    label: "C+",
                    value: 2.3
                },
                {
                    label: "C",
                    value: 2
                },
                {
                    label: "C-",
                    value: 1.7
                },
                {
                    label: "D+",
                    value: 1.3
                },
                {
                    label: "D",
                    value: 1
                },
                {
                    label: "F",
                    value: 0
                },
            ]
        }
    },
    methods: {
        initSemestersValue() {
            return [
              {
                  courses: [
                      new Course(),
                      new Course(),
                      new Course()
                  ]
              }
            ];
        },
        addCourse(semester) {
            semester.courses.push(new Course());
        },
        addSemester() {
            this.semesters.push({
                courses: [
                    new Course()
                ]
            });
        },
        calcSemesterGPA(semester) {
            const courses = semester.courses.filter(c => {
                return c.grade !== null && c.credits;
            })
            if (!courses.length) {
                return null;
            }
            const score = courses.reduce((partial, c) => {
                return partial + (c.grade * c.credits);
            }, 0);
            const credits = courses.reduce((partial, c) => {
                return partial + c.credits;
            }, 0);
            return Math.round((score/credits)*100)/100;
        },
        gpaStatus(gpa) {
            if (gpa === null) {
                return '';
            }
            if (gpa > 3.4) {
                return 'success';
            }
            if (gpa > 2.4) {
                return 'warning';
            }
            return 'error';
        },
        deleteSemester(semester) {
            const index = this.semesters.indexOf(semester);
            if (index < 0) {
                return;
            }
            this.semesters.splice(index, 1);
        },
        saveData() {
            if (typeof localStorage === 'undefined') {
                return;
            }
            localStorage.setItem(STORE_KEY, JSON.stringify(this.semesters));
        },
        resetData() {
            if (confirm('Are you want to reset all data ?')) {
                this.semesters = this.initSemestersValue();
                this.saveData();
            }
        }
    },
    computed: {
        results() {
            const r = [];
            this.semesters.forEach(s => {
                const gpa = this.calcSemesterGPA(s);
                r.push({
                    value: gpa,
                    percent: gpa/0.04,
                    status: this.gpaStatus(gpa)
                });
            });
            this.saveData();
            return r;
        },
        overallResult() {
            if (this.semesters.length < 2) {
                return null;
            }
            if (this.results.filter(r => r.value !== null).length !== this.semesters.length) {
                return null;
            }
            const gpa = this.results.reduce((partial, c) => partial+c.value, 0)/this.semesters.length;
            return {
                value: gpa,
                percent: gpa/0.04,
                status: this.gpaStatus(gpa)
            };
        }
    }
}).mount('#app')
